import { useTranslation } from "react-i18next";

import k1 from '../../img/Stock/k1.svg';
import k2 from '../../img/Stock/k2.svg';
import k3 from '../../img/Stock/k3.svg';
import k4 from '../../img/Stock/k4.svg';
import k5 from '../../img/Stock/k5.svg';

const HowTradeStock = () => {

    const { t } = useTranslation();

    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px] flex flex-col">
                <h4 className="md:text-[45px] font-[700] text-[28px] mx-auto text-[#0C2780] text-center">
                    {t('stock.13')}
                </h4>
                <p className="md:text-[19px] font-[700] text-[17px] mt-[15px] mx-auto text-[#0C2780] text-center">
                    {t('stock.14')}
                </p>
                <div className="flex flex-col xl:flex-row mt-[25px] xl:mt-[60px]">
                    <div className="relative px-[20px] pr-[50px] xl:pr-0 py-[25px] md:h-[212px] bg-[#FFFFFF] border-b xl:border-b-0 xl:border-r border-[#5191E8] w-full">
                        <img src={k1} alt="" />
                        <p className="mt-[15px] text-[#0C2780] text-[14px] xl:text-[16px]">{t('stock.15')}</p>
                        <svg className="absolute bottom-[12px] xl:bottom-[18px] right-[12px] xl:right-[33px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12L19 12" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19L19 12L12 5" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="relative px-[20px] pr-[50px] xl:pr-0 py-[25px] md:h-[212px] bg-[#FFFFFF] border-b xl:border-b-0 xl:border-r border-[#5191E8] w-full">
                        <img src={k2} alt="" />
                        <p className="mt-[15px] text-[#0C2780] text-[14px] xl:text-[16px]">{t('stock.16')}</p>
                        <svg className="absolute bottom-[12px] xl:bottom-[18px] right-[12px] xl:right-[33px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12L19 12" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19L19 12L12 5" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="relative px-[20px] pr-[50px] xl:pr-0 py-[25px] md:h-[212px] bg-[#FFFFFF] border-b xl:border-b-0 xl:border-r border-[#5191E8] w-full">
                        <img src={k3} alt="" />
                        <p className="mt-[15px] text-[#0C2780] text-[14px] xl:text-[16px]">{t('stock.17')}</p>
                        <svg className="absolute bottom-[12px] xl:bottom-[18px] right-[12px] xl:right-[33px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12L19 12" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19L19 12L12 5" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="relative px-[20px] pr-[50px] xl:pr-0 py-[25px] md:h-[212px] bg-[#FFFFFF] border-b xl:border-b-0 xl:border-r border-[#5191E8] w-full">
                        <img src={k4} alt="" />
                        <p className="mt-[15px] text-[#0C2780] text-[14px] xl:text-[16px]">{t('stock.18')}</p>
                        <svg className="absolute bottom-[12px] xl:bottom-[18px] right-[12px] xl:right-[33px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12L19 12" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19L19 12L12 5" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="relative px-[20px] pr-[50px] xl:pr-0 py-[25px] md:h-[212px] bg-[#FFFFFF] border-b xl:border-b-0 xl:border-r border-[#5191E8] w-full">
                        <img src={k5} alt="" />
                        <p className="mt-[15px] text-[#0C2780] text-[14px] xl:text-[16px]">{t('stock.19')}</p>
                        <svg className="absolute bottom-[12px] xl:bottom-[18px] right-[12px] xl:right-[33px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12L19 12" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19L19 12L12 5" stroke="#0C2780" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default HowTradeStock;
